"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorDialogStyled = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _designSystemBase = _interopRequireDefault(require("@nike/design-system-base"));

var _nikeDesignSystemComponents = require("@nike/nike-design-system-components");

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject;

var ErrorDialogStyled = (0, _styled.default)(_nikeDesignSystemComponents.DialogBaseStyled)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  min-height: 240px;\n\n  .error-dialog-container {\n    min-height: 240px !important;\n    padding: 48px 60px 36px 60px !important;\n  }\n\n  .error-dialog-header {\n    padding-top: 4px !important;\n    padding-bottom: 12px;\n  }\n\n  .title-heading {\n    line-height: 28px;\n    min-height: 28px;\n  }\n\n  .close-btn-container {\n    top: 2px !important;\n    right: 2px !important;\n  }\n\n  .dialog-close-button {\n    outline: none;\n  }\n\n  .error-dialog-content {\n    padding-right: 48px;\n  }\n\n  @media only screen and (max-width: ", "px) {\n    .error-dialog-container {\n      padding: 36px 24px 24px !important;\n    }\n  }\n"])), _designSystemBase.default.bp('tablet'));
exports.ErrorDialogStyled = ErrorDialogStyled;